const CommunicationRules = () => import('./CommunicationRules.vue')
const CommunicationRuleDetails = () => import('./CommunicationRuleDetails.vue')
const CommunicationDispatchHistory = () => import('./CommunicationDispatchHistory.vue')

export default [
  {
    name: 'communication-rules',
    path: 'rules',
    component: CommunicationRules,
    meta: {
      access: ['org.communication.rules.view']
    }
  },
  {
    name: 'communication-rule-new',
    path: 'rules/new',
    component: CommunicationRuleDetails,
    meta: {
      access: ['org.communication.rules.manage']
    }
  },
  {
    name: 'communication-rule-edit',
    path: 'rules/:id',
    component: CommunicationRuleDetails,
    meta: {
      access: ['org.communication.rules.manage']
    }
  },
  {
    name: 'communication-dispatch-history',
    path: 'dispatch-history',
    component: CommunicationDispatchHistory,
    meta: {
      access: ['org.communication.history.view']
    }
  }
]
